import { Directive, Input, TemplateRef } from "@angular/core";

@Directive({ selector: '[title-template]' })
export class TitleTemplateDirective {
    // Headers containing controls keep them separate from the sorting action.
    @Input('title-template') mode: '' | 'interactive' = '';
    constructor(public template: TemplateRef<any>) { }
}
